<template>
  <div class="deactive-brand" ref="mod" v-show="configs.modalType == 'deactive'">
    <template>
      <artmisads-modal
        :title="
          configs.type == 'single'
            ? configs.activeTab == '0'
              ? $t('seller.productTable.modalDeactivateSingleAttribution')
              : $t('seller.productTable.modalDeactivateSingleAssociate')
            : configs.activeTab == '0'
            ? $t('seller.productTable.modalDeactivateBulkAttribution')
            : $t('seller.productTable.modalDeactivateBulkAssociate')
        "
        v-model:open="configs.open"
        style="width: 900px"
        :getContainer="() => $refs.mod"
        :footer="false"
        :okText="$t('seller.common.confirm')"
      >
        <!-- @ok="onOk"
        @cancel="onModalCancel" -->
        <div class="deactive">
          <div class="top" v-if="configs.type == 'single'">
            <div class="top-left">
              <div
                class="brand-img-show"
                :style="
                  item?.imageUrl ? { background: 'rgba(238, 237, 242, 1)' } : ''
                "
              >
                <img :src="item?.imageUrl" v-if="item?.imageUrl" />
                <span class="brand-name" v-else>{{ item?.title }}</span>
              </div>
            </div>
            <div class="top-right">
              <div class="top-right-title">
                {{ item?.title }}
              </div>
              <div class="top-right-content">
                <div class="top-right-status">
                  <div class="top-right-status-title">
                    {{ $t('seller.common.status') }}
                  </div>
                  <Status
                    :type="item?.status?.toLowerCase()"
                    v-if="configs.activeTab == '0'"
                    :noBorder="true"
                    :text="
                      item?.status == 'active'
                        ? $t('seller.common.active')
                        : $t('seller.common.inactive')
                    "
                    style="margin-top: 4px"
                  />
                  <Status
                    :type="item?.associateStatus?.toLowerCase()"
                    v-if="configs.activeTab == '1'"
                    :noBorder="true"
                    :text="
                      item?.associateStatus == 'active'
                        ? $t('seller.common.active')
                        : $t('seller.common.inactive')
                    "
                    style="margin-top: 4px"
                  />
                </div>
                <div class="top-right-mid"></div>
                <div class="top-right-products">
                  <div class="top-right-status-title">
                    {{ $t('seller.productTable.labelAsin') }}
                  </div>
                  <a-popover placement="top">
                    <template #content>
                      {{ item?.asin }}
                    </template>

                    <div class="top-right-status-count">
                      {{ item?.asin }}
                    </div>
                  </a-popover>
                </div>
                <div class="top-right-mid"></div>
                <div class="top-right-products">
                  <div class="top-right-status-title">
                    {{ $t('seller.productTable.labelBrand') }}
                  </div>
                  <a-popover placement="top">
                    <template #content>
                      {{ item?.brandName }}
                    </template>

                    <div class="top-right-status-count">
                      {{ item?.brandName }}
                    </div>
                  </a-popover>
                </div>
                <div class="top-right-mid"></div>
                <div class="top-right-products">
                  <div class="top-right-status-title">
                    {{ $t('seller.productTable.labelPrice') }}
                  </div>
                  <a-popover placement="top">
                    <template #content>
                      {{ item?.currencySymbol }} {{ item?.price }}
                    </template>

                    <div class="top-right-status-count">
                      {{ item?.currencySymbol }} {{ item?.price }}
                    </div>
                  </a-popover>
                </div>
              </div>
            </div>
          </div>
          <div class="multi" v-else>
            <i18n-t
              keypath="seller.productTable.multiProductsSelected"
              tag="span"
            >
              <template #countProducts>
                <span class="boldBlack">{{ productCountInfo }}</span>
              </template>
            </i18n-t>
          </div>
          <div class="bottom">
            <div class="bottom-title">
              {{ $t('seller.brandsPage.importantNotice') }}
            </div>
            <div class="bottom-content">
              <Icon name="info-tianchong" class="tianchong" />
              <div>
                <p class="paragraph">
                  {{ $t('seller.productTable.deactivateNoticeP1') }}
                </p>

                <p class="paragraph" style="margin: 16px 0">
                  {{ $t('seller.productTable.deactivateNoticeP2Part1')
                  }} 
                  <span class="bold"> {{
                    $t('seller.productTable.deactivateNoticeToday')
                  }} </span> {{ $t('seller.productTable.deactivateNoticeP2Part2')
                  }}<span class="bold"> {{
                    $t('seller.productTable.deactivateNoticeBusinessDays')
                  }} </span
                  >{{ $t('seller.productTable.deactivateNoticeP2Part3') }}
                </p>

                <p class="paragraph">
                  {{ $t('seller.productTable.deactivateNoticeP3') }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="bottom-btn">
          <div class="bottom-btn-left">
            <p class="timeStyle">
              {{
                $t('seller.scheduledTaskModal.effectiveTime', {
                  time: timeYYYY,
                })
              }}
            </p>
          </div>
          <div class="bottom-btn-right">
            <artmisads-button type="default" @click="onModalCancel">
              {{ $t('seller.common.cancel') }}
            </artmisads-button>
            <artmisads-button type="primary" @click="onOk">
              {{ $t('seller.common.confirm') }}
            </artmisads-button>
          </div>
        </div>
      </artmisads-modal>
    </template>
  </div>
  <div ref="act" v-show="configs.modalType == 'active'">
    <template>
      <artmisads-modal
        v-model:open="configs.open"
        @ok="onOk"
        @cancel="onModalCancel"
        :footer="false"
        :getContainer="() => $refs.act"
        style="width: 900px"
        :title="
          configs.type == 'single'
            ? configs.activeTab == '0'
              ? $t('seller.productTable.modalActivateSingleAttribution')
              : $t('seller.productTable.modalActivateSingleAssociate')
            : configs.activeTab == '0'
            ? $t('seller.productTable.modalActivateBulkAttribution')
            : $t('seller.productTable.modalActivateBulkAssociate')
        "
        :okText="$t('seller.common.confirm')"
      >
        <div class="active-brand">
          <div class="top" v-if="configs.type == 'single'">
            <div class="top-left">
              <div
                class="brand-img-show"
                :style="
                  item?.imageUrl ? { background: 'rgba(238, 237, 242, 1)' } : ''
                "
              >
                <img :src="item?.imageUrl" v-if="item?.imageUrl" />
                <span class="brand-name" v-else>{{ item?.title }}</span>
              </div>
            </div>

            <div class="top-right">
              <div class="top-right-title">
                {{ item?.title }}
              </div>
              <div class="top-right-content">
                <div class="top-right-status">
                  <div class="top-right-status-title">
                    {{ $t('seller.common.status') }}
                  </div>
                  <Status
                    :type="item?.status?.toLowerCase()"
                    v-if="configs.activeTab == '0'"
                    :noBorder="true"
                    :text="
                      item?.status == 'active'
                        ? $t('seller.common.active')
                        : $t('seller.common.inactive')
                    "
                    style="margin-top: 2px"
                  />
                  <Status
                    :type="item?.associateStatus?.toLowerCase()"
                    v-if="configs.activeTab == '1'"
                    :noBorder="true"
                    :text="
                      item?.associateStatus == 'active'
                        ? $t('seller.common.active')
                        : $t('seller.common.inactive')
                    "
                    style="margin-top: 2px"
                  />
                </div>
                <div class="top-right-mid"></div>
                <div class="top-right-products">
                  <div class="top-right-status-title">
                    {{ $t('seller.productTable.labelAsin') }}
                  </div>
                  <a-popover placement="top">
                    <template #content>
                      {{ item?.asin }}
                    </template>

                    <div class="top-right-status-count">
                      {{ item?.asin }}
                    </div>
                  </a-popover>
                </div>
                <div class="top-right-mid"></div>
                <div class="top-right-products">
                  <div class="top-right-status-title">
                    {{ $t('seller.productTable.labelBrand') }}
                  </div>
                  <a-popover placement="top">
                    <template #content>
                      {{ item?.brandName }}
                    </template>

                    <div class="top-right-status-count">
                      {{ item?.brandName }}
                    </div>
                  </a-popover>
                </div>
                <div class="top-right-mid"></div>
                <div class="top-right-products">
                  <div class="top-right-status-title">
                    {{ $t('seller.productTable.labelPrice') }}
                  </div>
                  <a-popover placement="top">
                    <template #content>
                      {{ item?.currencySymbol }} {{ item?.price }}
                    </template>

                    <div class="top-right-status-count">
                      {{ item?.currencySymbol }} {{ item?.price }}
                    </div>
                  </a-popover>
                </div>
              </div>
            </div>
          </div>
          <div class="multi" v-else>
            <i18n-t
              keypath="seller.productTable.multiProductsSelected"
              tag="span"
            >
              <template #countProducts>
                <span class="boldBlack">{{ productCountInfo }}</span>
              </template>
            </i18n-t>
          </div>
          <div class="bottom">
            <div class="bottom-title">
              {{ $t('seller.brandsPage.importantNotice') }}
            </div>
            <div class="bottom-content">
              <Icon name="info-tianchong" class="tianchong" />
              <div>
                <p class="paragraph">
                  <span class="bold">{{
                    $t('seller.productTable.activateNoticeP1Bold')
                  }}</span
                  >{{ $t('seller.productTable.activateNoticeP1Rest') }}
                </p>

                <p class="paragraph" style="margin: 16px 0">
                  {{ $t('seller.productTable.activateNoticeP2Part1')
                  }}<span class="bold">{{
                    $t('seller.productTable.activateNoticeFollowingDay')
                  }} </span
                  >{{ $t('seller.productTable.activateNoticeP2Part2') }}
                </p>

                <p class="paragraph">
                  {{ $t('seller.productTable.activateNoticeP3') }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="bottom-btn">
          <div class="bottom-btn-left">
            <p class="timeStyle">
              <span class="boldBlackTime">{{
                $t('seller.scheduledTaskModal.effectiveTime', {
                  time: timeYYYY,
                })
              }}</span>
            </p>
          </div>
          <div class="bottom-btn-right">
            <artmisads-button type="default" @click="onModalCancel">
              {{ $t('seller.common.cancel') }}
            </artmisads-button>
            <artmisads-button type="primary" @click="onOk">
              {{ $t('seller.common.confirm') }}
            </artmisads-button>
          </div>
        </div>
      </artmisads-modal>
    </template>
  </div>
</template>
<script setup name="tableModal">
import { ref, reactive, toRefs, computed, watch, watchEffect } from 'vue'
import { message } from 'ant-design-vue'
import { imgCache } from '~/utils'
import Status from '@/components/Status.vue'
import Icon from '@/components/Icon.vue'
import moment from 'moment'

import {
  UpOutlined,
  DownOutlined,
  PlusOutlined,
  PauseOutlined,
  CloudUploadOutlined,
} from '@ant-design/icons-vue'
import { useUserInfoStore } from '@/storeData'
import { COUNTRY_FULL_NAME } from '@/contants/layout'
import { COUNTRY_TIME_TZ } from '~/contants/common.js'
import { useSystemStore } from '@/storeData/system'
import UploadImage from '@/components/uploadImage.vue'


const { configs, item, selectedRowKeys, productCountInfo } = defineProps({
  configs: {
    type: Object,
    default: () => { },
  },
  item: {
    type: Object,
    default: () => { },
  },
  selectedRowKeys: {
    type: Array,
    default: () => { },
  },
  productCountInfo: {
    type: Number,
    default: 0,
  },
})
const emit = defineEmits(['cancel', 'ok', 'okMulti'])
const user = useUserInfoStore()

const timezone = COUNTRY_TIME_TZ[user.userInfo.countryCode]
const timeYYYY = ref('')
const mod = ref()
const profile = ref()
const act = ref()
let nameChecked = ref()
const brandProfile = reactive({})
const isDisabled = ref(true) //按钮禁用
let biosValid = ref(false)
const country = computed(() => {
  return COUNTRY_FULL_NAME[user.userInfo.countryCode]
})
watch([() => configs.modalType], (newVal) => {
  if (newVal == 'updateProfile') {
    Object.assign(brandProfile, item)
  }
  if (newVal) {
    let nextWorkingDay = moment().tz(timezone)
    let workingDaysCount = 0
    if (newVal == 'active') {
      // Calculate next working day (Monday-Friday)
      while (workingDaysCount < 1) {
        nextWorkingDay = nextWorkingDay.add(1, 'day')
        if (nextWorkingDay.day() !== 0 && nextWorkingDay.day() !== 6) {
          workingDaysCount++
        }
      }
    } else {
      while (workingDaysCount < 4) {
        nextWorkingDay = nextWorkingDay.add(1, 'day')
        if (nextWorkingDay.day() !== 0 && nextWorkingDay.day() !== 6) {
          workingDaysCount++
        }
      }
    }
    timeYYYY.value = nextWorkingDay.format('YYYY-MM-DD')
  }
}, { immediate: true })
const onModalCancel = (e) => {
  emit('cancel')
}
const uploadImg = (res) => {
  try {
    if (res.data.url !== item.logoImageUrl) {
      isDisabled.value = false
    }
    brandProfile.logoImageUrl = res.data.url
  } catch (error) {
    console.log('upload-false')
  }
}
const onBios = (e) => {
  biosValid.value = false
  if (e.target.value !== item.biography) {
    isDisabled.value = false
  }
}
const onValiadBios = (e) => {
  // if (item.biography.length >= 1000) {
  if (brandProfile.biography && brandProfile.biography.length >= 1000) {
    biosValid.value = true
  }
}
const onOk = (e) => {
  let res = { ...item }
  // if (configs.modalType == "setCommission") {
  //   res.commissionRate = setCommission.commission;
  //   if (!res.commissionRate) {
  //     message.error("please input commission!", 1);
  //     return;
  //   }
  // }
  if (configs.type == 'single') {
    emit('ok', res)
  } else {
    emit('okMulti', selectedRowKeys, configs.modalType, productCountInfo)
  }
}
</script>
<style lang="less" scoped>
.bottom-btn {
  margin-top: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .timeStyle{
    display: flex;
    align-items: center;
  }
  .bottom-btn-right {
    display: flex;
    align-items: center;
    gap: 6px;
  }
}

@space: 16px;

@second-font: {
  opacity: 0.5;
  font-family: Sora, sans-serif;
  font-weight: 400;
  font-size: 14px;
  color: var(--dark-1);
  letter-spacing: 0.4px;
  line-height: 22px;
}

;

.multi {
  font-family: Sora;
  font-weight: 500;
  font-style: Medium;
  font-size: 16px;
  color: rgba(15, 6, 41, 0.5);
}

.boldBlack {
  font-family: Sora;
  font-weight: 600;
  font-style: SemiBold;
  font-size: 16px;
  color: rgba(15, 6, 41, 0.9);
}
.boldBlackTime{
  font-family: Sora;
  font-weight: 600;
  font-style: SemiBold;
  font-size: 13px;
  margin-left: 4px;
  color: rgba(15, 6, 41, 0.9);
}
.effectiveTime {
  font-family: Sora;
  font-weight: 400;
  font-style: Regular;
  font-size: 13px;
  color: rgba(15, 6, 41, 0.7);
  line-height: 19px;
  letter-spacing: 0.4px;

}

.top {
  display: flex;
  align-items: center;
  gap: 16px;

  .top-left {}

  .wenhao {
    fill: var(--dark-4);
  }

  .top-left {
    flex: 1;
  }

  .top-right {
    flex: 1;
    width: 86%;

    .top-right-title {
      font-family: Sora;
      font-weight: 500;
      font-style: Medium;
      font-size: 15px;
      margin-bottom: 16px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .top-right-content {
      display: flex;
      align-items: center;
      width: 100%;

      >div {
        display: flex;
        align-items: center;
        min-width: 0;
      }

      .top-right-status-title {
        font-family: Sora;
        font-weight: 500;
        font-style: Medium;
        font-size: 14px;
        color: rgba(135, 130, 148, 1);
        white-space: nowrap;
      }

      .top-right-status-count {
        font-family: Sora;
        font-weight: 500;
        font-size: 12px;
        line-height: 20px;
        margin-left: 4px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .top-right-status {
        display: flex;
        align-items: center;
        min-width: 0;
      }

      .top-right-mid {
        max-width: 2px;
        min-width: 2px;
        height: 10px;
        opacity: 1;
        background-color: rgba(232, 229, 237, 1);
        margin: 0 10px;
        flex-shrink: 0;
      }
    }

    .top-right-products {
      display: flex;
      align-items: center;
      min-width: 0;
    }
  }
}

.bottom {
  margin-top: 42px;

  .bottom-title {
    margin-bottom: 14px;
    font-family: Sora;
    font-weight: 500;
    font-size: 13px;
  }

  .bottom-content {
    border-radius: 8px;
    background-color: rgba(80, 64, 128, 0.08);
    padding: 10px;
    display: flex;
    gap: 10px;
  }

  .tianchong {
    color: rgba(131, 92, 242, 1);
    width: 18px;
    height: 18px;
    margin-top: 1px;
  }

  .paragraph {
    font-family: Sora;
    font-weight: 400;
    font-style: Regular;
    font-size: 13px;
  }

  .paragraphContent {
    font-family: Sora;
    font-weight: 700;
    font-style: Bold;
    font-size: 13px;
  }

  .bold {
    font-family: Sora;
    font-weight: 600;
    font-style: SemiBold;
    font-size: 13px;
    color: rgba(131, 92, 242, 1);
    padding: 0 3px;
  }
}

.title-ext {
  @second-font();
  margin-bottom: @space;
}

.modal-title {
  border-radius: 8px 8px 0 0;
  font-family: Sora, sans-serif;
  font-weight: 500;
  font-size: 20px;
  color: var(--dark-1);
  letter-spacing: 0.5px;
  line-height: 27px;
  margin-right: 16px;
}

.footer {
  display: flex;
  justify-content: flex-start;
}

.deactive-brand {
  .deactive {
    font-weight: 400;
    font-size: 14px;
    color: var(--dark-1);
    letter-spacing: 0.4px;
    line-height: 22px;
    // padding: 24px 17px 24px 24px;
  }
}

.active-brand {

  // padding: 24px 17px 24px 24px;
  .brand-name-row {
    margin-bottom: 8px;
    display: flex;
    flex-wrap: wrap;
  }

  .brand-name {
    font-family: Sora, sans-serif;
    font-weight: 500;
    font-size: 18px;
    color: var(--dark-1);
    letter-spacing: 0.4px;
    line-height: 21px;
  }

  .content {
    font-family: Sora, sans-serif;
    font-weight: 400;
    font-size: 14px;
    color: var(--dark-1);
    letter-spacing: 0.4px;
    line-height: 22px;
  }

  // .login-country{
  //   color: #999;
  // }
}

.update-brand-profile {
  :deep(label) {
    @second-font();
    opacity: 0.7;
    font-weight: 500;
    line-height: 20px;
  }

  .upload_part {
    display: flex;
    align-items: flex-end;
  }

  .upload {
    width: 120px;
    height: 120px;
    background: var(--big-bg-1);
    border-radius: 8px;
    margin-right: 8px;

    .upload-icon {
      border: 2px dashed var(--border-1);
      border-radius: 8px;
      @second-font();
      width: inherit;
      height: inherit;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 36px;

      &:hover {
        background-color: var(--bg-gray-2);
        border-color: var(--bg-gray-7);
      }
    }

    .upload-img {
      width: 100%;
      height: 100%;
      border-radius: 8px;

      img {
        width: 100%;
        height: 100%;
        border-radius: 8px;
      }

      &:hover {
        cursor: pointer;
      }
    }
  }

  .suggested {
    @second-font();
    letter-spacing: 0.3px;
    line-height: 18px;
    margin-top: 4px;
  }
}

.tip {
  padding: 8px;
  display: flex;
  margin-top: 16px;
  border-radius: 8px;
  color: var(--dark-2);
  background: var(--yellow-3);
  border: 1px solid var(--yellow-8);

  >.iconfont {
    flex: 1;
    height: 16px;
    font-size: 16px;
    min-width: 16px;
    margin-top: 2px;
    margin-right: 8px;
    color: var(--yellow-7);

    &:before {
      display: block;
      margin-top: -4px;
    }
  }
}

.brand-img-show {
  width: 72px;
  height: 72px;
  display: flex;
  border-radius: 8px;
  align-items: center;
  justify-content: center;
  background: var(--bg-gray-2);
  border: 1px solid rgba(238, 237, 242, 1);

  img {
    border-radius: 8px;
   width: 72px;
  height: 72px;
    object-fit: contain;
  }

  .brand-name {
    margin: 0 auto;
    padding: 0 4px;
    max-width: 56px;
    font-size: 11px;
    overflow: hidden;
    max-height: 39px;
    font-weight: 600;
    line-height: 13px;
    text-align: center;
    color: var(--dark-4);
    letter-spacing: 0.3px;
  }
}
</style>
